import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLoaderData, useParams } from 'react-router';
import { SubscriptionCategory } from '../../../../../../common/enums.js';
import { EoeSubscriptionDetailsDevice } from '../../../../../../components/EoeSubscriptionDetails/EoeSubscriptionDetailsDevice.js';
import {
  checkValidEmployeeSubscription,
  getEmployeeSubscriptions,
} from '../../../../../../selfservice/actions/index.js';
import { useSessionData } from '../../../../SessionDataProvider.js';
import type { SubscriptionId } from '../../../../../../common/constants/pathInterfaces.js';
import type { EoeDevicePathLoaderData } from '../../../../../../common/loaders.js';

export const EoeDevicePath = () => {
  const dispatch = useDispatch();
  const companyInfo = useSessionData().companyInfo;
  const { subscriptionId = '' } = useParams<SubscriptionId>();
  const { contacts } = useLoaderData() as EoeDevicePathLoaderData;

  useEffect(() => {
    dispatch(getEmployeeSubscriptions(SubscriptionCategory.DEVICE, subscriptionId));
    dispatch(checkValidEmployeeSubscription(SubscriptionCategory.DEVICE, subscriptionId));
  }, [dispatch, subscriptionId]);

  return (
    <EoeSubscriptionDetailsDevice
      subscriptionId={subscriptionId}
      companyInfo={companyInfo}
      contacts={contacts.contacts}
    />
  );
};
